<script>
import { reactive, watch } from 'vue';

export default {};
</script>

<template>
  <slot />
</template>
